/**
 * What a store snapshot hands the app that replaces it (ADR-043): the data the
 * page was drawn from, in a `<script type="application/json">` element in
 * `<head>`, so the app's first render paints the same page with no request and
 * no loading state. The app reads it once, for the page it was drawn for, and
 * removes it.
 */
import type {
  StoreAppPageData,
  StoreAppsPageData,
  StoreCategoryRef,
  StoreCollectionData,
  StoreHomeData,
  StoreTopData,
} from './types';

/** The `id` of the `<script type="application/json">` element in `<head>`. */
export const STORE_SNAPSHOT_DATA_ELEMENT_ID = 'fias-store-data';

/** Bumped when the handoff's shape changes; the app ignores any other version. */
export const STORE_SNAPSHOT_DATA_VERSION = 1;

/** One page's data, as the store API answers it. */
export type StorePageData =
  | { kind: 'home'; home: StoreHomeData }
  | { kind: 'categories'; categories: StoreCategoryRef[] }
  | { kind: 'top'; top: StoreTopData; categories: StoreCategoryRef[] }
  | { kind: 'category'; categoryId: string; page: StoreAppsPageData }
  | { kind: 'story'; slug: string; story: StoreCollectionData }
  | { kind: 'app'; slug: string; app: StoreAppPageData };

export interface StoreSnapshotHandoff {
  v: typeof STORE_SNAPSHOT_DATA_VERSION;
  /** The page this data was drawn for: `/a/store`, `/a/store/app/<slug>`, … */
  path: string;
  data: StorePageData;
}
